'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthAfter;


// WEBPACK FOOTER //
// ./~/sugar-date/number/monthAfter.js